import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=1bf2e57e&scoped=true"
import script from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=1bf2e57e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf2e57e",
  null
  
)

export default component.exports